import React, { createContext, useContext, useEffect, useState } from "react";

type PlatformTheme = "tech" | "fresh";

interface ThemeContextType {
  platformTheme: PlatformTheme;
  setPlatformTheme: (theme: PlatformTheme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [platformTheme, setPlatformThemeState] = useState<PlatformTheme>(() => {
    const stored = localStorage.getItem("platformTheme");
    return (stored === "tech" || stored === "fresh") ? stored : "tech";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (platformTheme === "fresh") {
      root.classList.add("theme-fresh");
    } else {
      root.classList.remove("theme-fresh");
    }
    localStorage.setItem("platformTheme", platformTheme);
  }, [platformTheme]);

  const setPlatformTheme = (theme: PlatformTheme) => {
    setPlatformThemeState(theme);
  };

  return (
    <ThemeContext.Provider value={{ platformTheme, setPlatformTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return context;
}
